var url = "b455c7ef0829ca2bc8aa93dac0ba1dfd.png";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;